// Razorpay Checkout helper — loads checkout.js on demand and opens the modal.
let _scriptPromise = null;

export const loadRazorpayScript = () => {
  if (window.Razorpay) return Promise.resolve(true);
  if (_scriptPromise) return _scriptPromise;
  _scriptPromise = new Promise((resolve) => {
    const script = document.createElement('script');
    script.src = 'https://checkout.razorpay.com/v1/checkout.js';
    script.onload = () => resolve(true);
    script.onerror = () => resolve(false);
    document.body.appendChild(script);
  });
  return _scriptPromise;
};

// Detect a country hint from the browser timezone (India => 'IN').
export const detectCountryHint = () => {
  try {
    const tz = Intl.DateTimeFormat().resolvedOptions().timeZone || '';
    if (tz.includes('Kolkata') || tz.includes('Calcutta')) return 'IN';
  } catch (e) { /* noop */ }
  return undefined;
};

/**
 * Open the Razorpay one-time payment modal for an Order.
 * Returns a promise that resolves with the payment response or rejects on dismiss.
 */
export const openRazorpayOrder = async ({ order, keyId, name = 'Lockene CRM', description = '', prefill = {}, theme = { color: '#6366f1' } }) => {
  const ok = await loadRazorpayScript();
  if (!ok || !window.Razorpay) throw new Error('Failed to load Razorpay');
  return new Promise((resolve, reject) => {
    const rzp = new window.Razorpay({
      key: keyId,
      order_id: order.order_id,
      amount: order.amount,
      currency: order.currency || 'INR',
      name,
      description,
      prefill,
      theme,
      handler: (response) => resolve(response),
      modal: { ondismiss: () => reject(new Error('dismissed')) },
    });
    rzp.open();
  });
};

/**
 * Open the Razorpay modal to authorize a Subscription mandate (autopay).
 * Resolves with { razorpay_payment_id, razorpay_subscription_id, razorpay_signature }.
 */
export const openRazorpaySubscription = async ({ subscriptionId, keyId, name = 'Lockene CRM', description = '', prefill = {}, theme = { color: '#6366f1' } }) => {
  const ok = await loadRazorpayScript();
  if (!ok || !window.Razorpay) throw new Error('Failed to load Razorpay');
  return new Promise((resolve, reject) => {
    const rzp = new window.Razorpay({
      key: keyId,
      subscription_id: subscriptionId,
      name,
      description,
      prefill,
      theme,
      handler: (response) => resolve(response),
      modal: { ondismiss: () => reject(new Error('dismissed')) },
    });
    rzp.open();
  });
};
